export { default } from './TableBody';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableBody/index.js
// module id = 360
// module chunks = 0